import Cookies from "universal-cookie/es6";

export class SessionStorage{
    public add(key: string, value: string){
        sessionStorage.setItem(key,value);
    }
   public has(key: string): boolean{
        return sessionStorage.getItem(key) !== undefined && sessionStorage.getItem(key) !== null;
    }

    public get(key : string) : string {
        return sessionStorage.getItem(key) as string ;
    }

    public addCookie(key : string, value : string){
        const cookie = new Cookies();
        cookie.set(key, value, { secure: true, sameSite: "lax", path: "/" })
    }

    public getCookie(key: string): string | undefined {
        const cookie = new Cookies();
        return cookie.get(key);
    }

    public changeItemValue(key: string, newValue: string){
        sessionStorage.setItem(key, newValue);
    }

    public remove(key: string){
        sessionStorage.removeItem(key);
    }

}


